"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Dashboard_1 = require("./Dashboard");
var StringUtils_1 = require("@twii/core/lib/StringUtils");
var DashboardAdd = /** @class */ (function () {
    function DashboardAdd() {
        this.active = false;
        this.makeActive = true;
    }
    DashboardAdd.prototype.init = function (opts) {
        this.dashboardList = opts.dashboardList;
        this.dashboard = new Dashboard_1.Dashboard();
        this.existing = opts.existing;
        var dashboardNumber = 1;
        var suggestedTitle;
        while (true) {
            suggestedTitle = "Dashboard " + dashboardNumber;
            if (!this.dashboardList.dashboards.some(function (db) { return db.title === suggestedTitle; })) {
                break;
            }
            else {
                dashboardNumber++;
            }
        }
        this.dashboard.setTitle(suggestedTitle);
        this.active = true;
    };
    DashboardAdd.prototype.setExisting = function (existing) {
        this.existing = existing;
    };
    DashboardAdd.prototype.setMakeActive = function (makeActive) {
        this.makeActive = makeActive;
    };
    DashboardAdd.prototype._close = function () {
        this.existing = undefined;
        this.dashboardList = undefined;
        this.active = false;
    };
    Object.defineProperty(DashboardAdd.prototype, "saveEnabled", {
        get: function () {
            return StringUtils_1.isNotBlank(this.dashboard.title) ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    DashboardAdd.prototype.save = function () {
        if (this.existing) {
            this.dashboard.setComponentConfig(this.existing.componentConfig);
        }
        this.dashboardList.add(this.dashboard, this.makeActive);
        this._close();
    };
    DashboardAdd.prototype.cancel = function () {
        this._close();
    };
    __decorate([
        mobx_1.observable
    ], DashboardAdd.prototype, "active", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardAdd.prototype, "dashboardList", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardAdd.prototype, "existing", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardAdd.prototype, "dashboard", void 0);
    __decorate([
        mobx_1.observable
    ], DashboardAdd.prototype, "makeActive", void 0);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "init", null);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "setExisting", null);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "setMakeActive", null);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "_close", null);
    __decorate([
        mobx_1.computed
    ], DashboardAdd.prototype, "saveEnabled", null);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "save", null);
    __decorate([
        mobx_1.action
    ], DashboardAdd.prototype, "cancel", null);
    return DashboardAdd;
}());
exports.DashboardAdd = DashboardAdd;
